import { render, staticRenderFns } from "./MemberAuthentication.vue?vue&type=template&id=39ad68c4&"
import script from "./MemberAuthentication.vue?vue&type=script&lang=ts&"
export * from "./MemberAuthentication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports